import { getBoardId } from '@atlassian/jira-router-resources-utils/src/utils/get-board-id/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router
import { createResource } from '@atlassian/react-resource-router';
import { fetchJSWReports } from '../../../services/sidebar/jsw-reports-sidebar-navigation/main.tsx';
import type { JiraSoftwareReport } from '../../../services/sidebar/jsw-reports-sidebar-navigation/types.tsx';

export const staticSidebarJSWReportsResource = createResource<JiraSoftwareReport[] | null>({
	type: 'JIRA_SOFTWARE_REPORTS',
	getKey: ({ match, query }) => {
		const boardId = getBoardId(match, query);
		return boardId ? `board-${boardId}` : 'none';
	},
	getData: async ({ match, query }) => {
		const boardId = getBoardId(match, query);
		if (boardId == null) {
			return null;
		}
		const response = await fetchJSWReports(boardId);
		return response?.reports;
	},
	maxAge: 5 * 60 * 1000,
	isCritical: true,
});
